module.exports = __webpack_public_path__ + "img/sprinkle-8.b6ec3548.jpg";